import MasterCashSchedualeComponent from './master_cash_schedule.component';
import printMasterCashSchedule from './print';

let masterCashScheduleModule = angular.module('masterCashSchedule', [
    printMasterCashSchedule
])

    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $urlRouterProvider.otherwise('/master-cash-schedule');

        $stateProvider
            .state('masterCashSchedule', {
                url: '/master-cash-schedule',
                component: 'masterCashSchedule',
                data: {
                    requireLogin: true,
                    requireACL: 'master_cash_schedule.view'
                },
                parent: 'app'
            });
    })

    .component('masterCashSchedule', MasterCashSchedualeComponent)

    .name;

export default masterCashScheduleModule;


// WEBPACK FOOTER //
// ./client/app/components/master_cash_schedule/index.js